import { createApi } from "@reduxjs/toolkit/query/react";
import { setAccessToken, setRefreshToken } from "../slices/authSlice";
import Cookies from "js-cookie";
import axios from "axios";
import getTenantId from "../../components/Tenent";
import { showAccessDeniedModal } from "../slices/authSlice";

const getStore = () => require("../store").store;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ACTIVITIES_HOST_URL,
  withCredentials: true,
  headers: {
    accept: `application/json`,
  },
});

const setUpInterceptors = (getState, dispatch) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const parsedURL = new URL(window.location.href);

      const subdomain = parsedURL?.hostname?.split(".")?.[0];
      const tenantId = getTenantId();

      if (subdomain === "localhost") {
        config.headers["x-tenant-id"] = tenantId;
      } else {
        config.baseURL = config.baseURL?.replace("www", subdomain);
        config.headers["x-tenant-id"] = subdomain;
      }
      const token = Cookies.get("access_token");
      const refresh_token = Cookies.get("refresh_token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["Refresh"] = `Bearer ${refresh_token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (res) => res,
    async (err) => {
      const originalConfig = err.config;
      const errorMessage = err.response?.data?.error || "";

      if (
        err.response?.status === 401 &&
        errorMessage.includes("access token has expired") &&
        !originalConfig._retry
      ) {
        originalConfig._retry = true;

        const accessToken = Cookies.get("access_token");
        const refreshToken = Cookies.get("refresh_token");

        if (!refreshToken || !accessToken) {
          dispatch(setAccessToken(null));
          dispatch(setRefreshToken(null));
          return Promise.reject(err);
        }

        try {
          // Determine the correct tenant ID
          const parsedURL = new URL(window.location.href);
          const subdomain = parsedURL?.hostname?.split(".")?.[0];
          const tenantId = getTenantId();

          const refreshHeaders = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${refreshToken}`,
            "x-tenant-id": subdomain === "localhost" ? tenantId : subdomain,
          };
          // Request new tokens from `/auth/core/refresh`
          const { data } = await axios.post(
            `${process.env.REACT_APP_AUTH_API}/core/refresh`,
            {
              access_token: accessToken,
              refresh_token: refreshToken,
            },
            { headers: refreshHeaders }
          );
          console.log(data?.refresh_token);
          console.log(data?.access_token);
          // Save new tokens in Redux
          dispatch(setAccessToken(data?.access_token));
          dispatch(setRefreshToken(data?.refresh_token));

          // Retry the original request with the new token
          originalConfig.headers[
            "Authorization"
          ] = `Bearer ${data?.access_token}`;
          originalConfig.headers["Refresh"] = `Bearer ${data?.refresh_token}`;
          return axiosInstance(originalConfig);
        } catch (_error) {
          dispatch(setAccessToken(null));
          dispatch(setRefreshToken(null));
          return Promise.reject(_error);
        }
      }

      return Promise.reject(err);
    }
  );
};

const axiosBaseQuery =
  () =>
  async (
    { url, method, body, params, excludeTenantIdFromBody, ...requestOpts },
    { getState, dispatch }
  ) => {
    setUpInterceptors(getState, dispatch);

    const tenantId = localStorage.getItem("X-Tenant-Id") || getTenantId();

    const enhancedBody =
      method === "POST" && !excludeTenantIdFromBody
        ? {
            ...body,
            "X-Tenant-Id": tenantId,
          }
        : body;

    const enhancedHeaders =
      method === "GET"
        ? {
            ...requestOpts.headers,
            "X-Tenant-Id": tenantId,
          }
        : requestOpts.headers;

    try {
      const axiosOptions = {
        url: url,
        method,
        data: enhancedBody,
        params,
        headers: enhancedHeaders,
      };

      const result = await axiosInstance(axiosOptions);
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError;
      const errorData = axiosError.response?.data;
      const status = axiosError.response?.status;

      if (status === 403 && errorData?.error === "forbidden") {
        getStore().dispatch(showAccessDeniedModal());
      }
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const reportss3api = createApi({
  reducerPath: "s3purchasedgoodsApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["s3purchasedgoods"],
  endpoints: (builder) => ({
    getToken: builder.mutation({
      query: () => ({
        url: `login`,
        method: "POST",
        body: {
          API_KEY: process.env.REACT_APP_ACTIVITIES_HOST_API_KEY,
        },
      }),
      invalidatesTags: ["activities"],
    }),
    Adds3Item: builder.mutation({
      query: ({ token, payload }) => {
        const tenantId = localStorage.getItem("X-Tenant-Id") || getTenantId();
        const tenantHeader = tenantId;

        const enhancedPayload = {
          ...payload,
          "X-Tenant-Id": tenantHeader,
        };

        return {
          url: `/process_input_file/`,
          method: "POST",
          body: enhancedPayload,
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Tenant-Id": tenantHeader,
          },
        };
      },
      invalidatesTags: ["s3purchasedgoods"],
    }),

    bulkDeleteItems: builder.mutation({
      query: ({ fileName, purgeData }) => {
        const tenantId = localStorage.getItem("X-Tenant-Id") || getTenantId();
        const tenantHeader = tenantId;
        return {
          url: `/delete_input_file/?fileName=${fileName}&purge_data=${purgeData}`,
          method: "DELETE",
          headers: {
            "X-Tenant-Id": tenantHeader,
          },
        };
      },
      invalidatesTags: ["input-items"],
    }),

    Gets3progress: builder.query({
      query: ({ token }) => {
        const tenantId = localStorage.getItem("X-Tenant-Id") || getTenantId();
        const tenantHeader = tenantId;

        return {
          url: `/get_s3_file_job_status/`,
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Tenant-Id": tenantHeader,
          },
        };
      },
      providesTags: ["s3purchasedgoods"],
    }),

    Getfoldernames3: builder.query({
      query: ({ token }) => {
        const tenantId = localStorage.getItem("X-Tenant-Id") || getTenantId();
        const tenantHeader = tenantId;

        return {
          url: `/get_folder_name_s3`,
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Tenant-Id": tenantHeader,
          },
        };
      },
      providesTags: ["s3purchasedgoods"],
    }),

    MergeexcelsS3: builder.query({
      query: ({ token, payload }) => {
        const tenantId = localStorage.getItem("X-Tenant-Id") || getTenantId();
        const tenantHeader = tenantId;

        return {
          url: `/merge_excels_S3`,
          method: "POST",
          body: payload,
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Tenant-Id": tenantHeader,
          },
        };
      },
      providesTags: ["s3purchasedgoods"],
    }),

    MergedownloadS3: builder.query({
      query: ({ token }) => {
        const tenantId = localStorage.getItem("X-Tenant-Id") || getTenantId();
        const tenantHeader = tenantId;

        return {
          url: `/download-folder`,
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Tenant-Id": tenantHeader,
          },
        };
      },
      providesTags: ["s3purchasedgoods"],
    }),

    Gets3files: builder.query({
      query: ({ token, name }) => {
        const tenantId = localStorage.getItem("X-Tenant-Id") || getTenantId();

        const isCentral = name === "centralized";

        return {
          url: `/fetch_input_files/`,
          params: {
            ...(isCentral && { isCentral: true }), // Pass isCentral as a query parameter
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Tenant-Id": tenantId,
          },
        };
      },
      providesTags: ["s3purchasedgoods"],
    }),

    Filedownload: builder.mutation({
      query: ({ token, payload }) => {
        const tenantId = localStorage.getItem("X-Tenant-Id") || getTenantId();

        const enhancedPayload = {
          ...payload,
          "X-Tenant-Id": tenantId,
        };

        return {
          url: `/get_file/`,
          method: "POST",
          body: enhancedPayload,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      invalidatesTags: ["s3purchasedgoods"],
    }),
    Centralizedfile: builder.mutation({
      query: ({ token, payload }) => {
        const tenantId = localStorage.getItem("X-Tenant-Id") || getTenantId();

        const enhancedPayload = {
          ...payload,
        };

        return {
          url: `/process_central_file/`,
          method: "POST",
          body: enhancedPayload,
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Tenant-Id": tenantId,
          },
        };
      },
      invalidatesTags: ["s3purchasedgoods"],
    }),

    DownloadoutputFile: builder.mutation({
      query: ({ token, payload }) => {
        const tenantId = localStorage.getItem("X-Tenant-Id") || getTenantId();

        const enhancedPayload = {
          ...payload,
          "X-Tenant-Id": tenantId,
        };

        return {
          url: `/get_file_url/`,
          method: "POST",
          body: enhancedPayload,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      invalidatesTags: ["s3purchasedgoods"],
    }),
    DeleteFile: builder.mutation({
      query: ({ token, payload }) => {
        const tenantId = localStorage.getItem("X-Tenant-Id") || getTenantId();

        const enhancedPayload = {
          ...payload,
        };

        console.log("enhancedPayloadsadsadsa", enhancedPayload);

        return {
          url: `/delete_other_categories_input_file/`,
          method: "DELETE",
          body: enhancedPayload,
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Tenant-Id": tenantId,
          },
        };
      },
      invalidatesTags: ["s3purchasedgoods"],
    }),
  }),
});

export const {
  useAdds3ItemMutation,
  useGets3progressQuery,
  useGetfoldernames3Query,
  useLazyMergeexcelsS3Query,
  useLazyMergedownloadS3Query,
  useGets3filesQuery,
  useFiledownloadMutation,
  useCentralizedfileMutation,
  useBulkDeleteItemsMutation,
  useGetTokenMutation,
  useDownloadoutputFileMutation,
  useDeleteFileMutation,
} = reportss3api;
